<template>
  <div id="second-profile-form">
    <section class="columns">
      <div class="column">
        <div class="columns">
          <div class="column">
            <div class="field columns">
              <div class="control column">
                <label class="label">เชื้อชาติ</label>
                <input class="input" type="text" placeholder="เชื้อชาติ" v-model="formData.race">
              </div>
              <div class="control column">
                <label class="label">สัญชาติ</label>
                <input class="input" type="text" placeholder="สัญชาติ" v-model="formData.nationality">
              </div>
              <div class="control column">
                <label class="label">ศาสนา</label>
                <div class="select is-fullwidth">
                  <select v-model="formData.religion">
                    <option>พุทธ</option>
                    <option>คริสต์</option>
                    <option>อิสลาม</option>
                    <option>อื่น ๆ</option>
                  </select>
                </div>
              </div>
              <div class="control column">
                <label class="label">โรคประจำตัว (ถ้ามี)</label>
                <input class="input" type="text" placeholder="โรคประจำตัว" v-model="formData.congenitalDisease">
              </div>
              <div class="control column">
                <label class="label">กรุ๊ปเลือด</label>
                <div class="select is-fullwidth">
                  <select v-model="formData.bloodType">
                    <option>A</option>
                    <option>B</option>
                    <option>O</option>
                    <option>AB</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="columns">

      <div class="field column">
        <div class="control">
          <label class="label">แพ้ยา</label>
          <input class="input" type="text" placeholder="ยาที่เเพ้ 1, ยาที่แพ้ 2, ..." v-model="formData.drugAllergy">
        </div>
      </div>
      <div class="field column">
        <div class="control">
          <label class="label">แพ้อาหาร</label>
          <input class="input" type="text" placeholder="อาหารที่แพ้ 1, อาหารที่แพ้ 2, ..." v-model="formData.foodAllergies">
        </div>
      </div>
    </section>
  </div>
</template>

<script>
    export default {
        name: "SecondRegisterForm",
        data: function () {
            return {
                formData: {}
            }
        },
        methods: {},
        watch: {
            userFormDataState(newFormState) {
                this.formData = newFormState;
            },
            async formValue() {
                await this.$store.dispatch('setUserFormData', this.formData)
            }
        },
        computed: {
            formValue() {
                return Object.values(this.formData);
            },
            userFormDataState() {
                return this.$store.getters.userFormData;
            }
        }
    }
</script>

<style scoped>

</style>
